// extracted by mini-css-extract-plugin
module.exports = {"container":"blog_container__2dwNE","header":"blog_header___Db3a","title":"blog_title__tccHe","img":"blog_img__sR8Ff"};